import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-8" data-id="element-249">
      <div className="max-w-7xl mx-auto px-6" data-id="element-250">
        <div id="locations" className="grid md:grid-cols-3 gap-6 mb-6" data-id="element-251">
          <div data-id="element-252">
            <h3 className="font-semibold text-sm mb-2" data-id="element-253">Fight Club Med Spa</h3>
            <div className="text-gray-300 text-sm" data-id="element-254">
              <p className="mb-1" data-id="element-255">Martha Carey-Lee, MS, FNP-C, LSO</p>
              <a href="tel:18666152001" className="hover:text-white transition-colors block" data-id="element-256">
                1(866) 615-2001 (text me)
              </a>
              <a href="mailto:martha@fcmedspa.com" className="hover:text-white transition-colors" data-id="element-257">
                martha@fcmedspa.com
              </a>
            </div>
          </div>
          <div data-id="element-258">
            <h3 className="font-semibold text-sm mb-2" data-id="element-259">Retail Location</h3>
            <div className="text-gray-300 text-sm" data-id="element-260">
              <p data-id="element-261">Phoenix, AZ</p>
              <p data-id="element-262">6070 N 16th St</p>
              <p data-id="element-263">Phoenix, AZ 85014</p>
            </div>
          </div>
          <div data-id="element-264">
            <h3 className="font-semibold text-sm mb-2" data-id="element-265">Concierge Locations</h3>
            <div className="text-gray-300 text-sm space-y-2" data-id="element-266">
              <p data-id="element-267">Santa Barbara, CA</p>
              <p data-id="element-268">SF Bay Area, CA</p>
              <p data-id="element-269">Chicago, IL</p>
              <p data-id="element-270">Tucson, AZ</p>
            </div>
          </div>
        </div>
        <div className="text-center text-gray-400 text-xs pt-6 border-t border-gray-800" data-id="element-271">
          <p data-id="element-272">
            © {new Date().getFullYear()} Fight Club Med Spa. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}